export const categories = [
  {
    id: 1,
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    count: '350+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20designer%20sneakers%20displayed%20on%20minimalist%20concrete%20pedestal%20with%20dramatic%20side%20lighting%20casting%20artistic%20shadows%2C%20dark%20moody%20background%20with%20subtle%20gradient%2C%20luxury%20product%20photography%2C%20high%20contrast%2C%20editorial%20fashion%20aesthetic%2C%20rich%20textures%20and%20premium%20materials%20visible&width=520&height=320&seq=cat-v2-shoes-01&orientation=landscape',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    count: '280+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20knit%20hoodie%20draped%20over%20vintage%20wooden%20chair%20near%20sunlit%20window%20with%20soft%20morning%20light%20streaming%20through%2C%20warm%20terracotta%20and%20cream%20tones%2C%20steaming%20coffee%20cup%20on%20rustic%20side%20table%2C%20cozy%20cabin%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20hygge%20atmosphere&width=520&height=320&seq=cat-v2-hoodies-02&orientation=landscape',
  },
  {
    id: 3,
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    count: '420+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20perfectly%20folded%20graphic%20t-shirts%20stacked%20on%20white%20marble%20surface%2C%20vibrant%20coral%20pink%20and%20sage%20green%20colors%2C%20tropical%20monstera%20leaf%20shadow%20falling%20across%2C%20bright%20Mediterranean%20natural%20light%20streaming%2C%20summer%20vacation%20aesthetic%2C%20clean%20modern%20composition%2C%20high%20end%20casual%20fashion&width=520&height=320&seq=cat-v2-tshirts-03&orientation=landscape',
  },
  {
    id: 4,
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
    count: '190+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20bomber%20jacket%20hanging%20elegantly%20on%20brass%20wall%20hook%20against%20exposed%20red%20brick%20wall%2C%20warm%20amber%20lighting%20from%20overhead%20industrial%20pendant%20lamp%2C%20loft%20apartment%20setting%2C%20evening%20golden%20hour%20mood%2C%20sophisticated%20urban%20fashion%20photography%2C%20rich%20textures&width=520&height=320&seq=cat-v2-jackets-04&orientation=landscape',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    count: '310+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20and%20casual%20shorts%20artfully%20arranged%20on%20light%20oak%20parquet%20floor%2C%20soft%20diffused%20window%20light%20from%20sheer%20curtains%2C%20minimal%20Scandinavian%20interior%20aesthetic%2C%20natural%20earth%20tones%20and%20sandy%20hues%2C%20editorial%20flat%20lay%20photography%2C%20relaxed%20weekend%20style&width=520&height=320&seq=cat-v2-pants-05&orientation=landscape',
  },
  {
    id: 6,
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-star-line',
    count: '150+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20baseball%20caps%20and%20bucket%20hats%20displayed%20on%20mid-century%20modern%20wooden%20hat%20stand%2C%20bright%20pop%20art%20inspired%20pastel%20yellow%20and%20mint%20green%20background%2C%20playful%20youthful%20composition%2C%20fun%20energetic%20commercial%20fashion%20photography%2C%20bold%20color%20blocking%2C%20creative%20display&width=520&height=320&seq=cat-v2-headwear-06&orientation=landscape',
  },
  {
    id: 7,
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    count: '120+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20coordinated%20two%20piece%20outfit%20displayed%20on%20invisible%20mannequin%20against%20soft%20sage%20green%20studio%20backdrop%2C%20elegant%20fabric%20draping%2C%20high%20fashion%20editorial%20style%2C%20soft%20directional%20studio%20lighting%20creating%20gentle%20shadows%2C%20luxury%20clothing%20presentation%2C%20refined%20sophisticated%20aesthetic&width=520&height=320&seq=cat-v2-sets-07&orientation=landscape',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    count: '200+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20undergarments%20artfully%20arranged%20with%20dried%20lavender%20sprigs%20and%20eucalyptus%20branches%20on%20textured%20natural%20linen%20fabric%2C%20spa%20like%20zen%20atmosphere%2C%20diffused%20gentle%20morning%20light%2C%20clean%20wellness%20aesthetic%2C%20calming%20neutral%20tones%2C%20botanical%20still%20life%20photography&width=520&height=320&seq=cat-v2-underwear-08&orientation=landscape',
  },
  {
    id: 9,
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    count: '180+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Authentic%20sports%20jersey%20casually%20draped%20over%20stadium%20bleacher%20seat%2C%20golden%20hour%20sunset%20light%20creating%20dramatic%20warm%20glow%2C%20slightly%20blurred%20stadium%20background%20with%20atmospheric%20haze%2C%20nostalgic%20sports%20photography%2C%20emotional%20aspirational%20mood%2C%20cinematic%20color%20grading&width=520&height=320&seq=cat-v2-jersey-09&orientation=landscape',
  },
  {
    id: 10,
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    count: '260+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20gold%20toned%20jewelry%2C%20designer%20sunglasses%2C%20and%20silk%20scarf%20arranged%20on%20deep%20navy%20blue%20velvet%20display%20tray%2C%20warm%20focused%20spotlight%20illumination%20creating%20rich%20metallic%20reflections%2C%20luxury%20boutique%20photography%2C%20glamorous%20sophisticated%20atmosphere%2C%20dark%20moody%20elegance&width=520&height=320&seq=cat-v2-accessories-10&orientation=landscape',
  },
  {
    id: 11,
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    count: '230+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20leather%20handbag%20placed%20on%20marble%20bistro%20table%20at%20outdoor%20European%20cafe%2C%20soft%20afternoon%20sunlight%20filtering%20through%20striped%20awning%2C%20blurred%20cobblestone%20street%20background%20with%20passersby%2C%20romantic%20Parisian%20travel%20aesthetic%2C%20golden%20hour%20warmth%2C%20sophisticated%20lifestyle%20photography&width=520&height=320&seq=cat-v2-bags-11&orientation=landscape',
  },
  {
    id: 12,
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    count: '140+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20artfully%20coiled%20and%20displayed%20on%20reclaimed%20dark%20walnut%20wood%20workbench%20surface%2C%20leather%20crafting%20tools%20partially%20visible%20in%20soft%20background%20blur%2C%20warm%20tungsten%20workshop%20lighting%2C%20artisanal%20craftsmanship%20photography%2C%20rich%20brown%20leather%20textures%2C%20handmade%20quality%20aesthetic&width=520&height=320&seq=cat-v2-belts-12&orientation=landscape',
  },
  {
    id: 13,
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-bubble-chart-line',
    count: '100+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20perfume%20bottles%20with%20golden%20metallic%20accents%20arranged%20on%20reflective%20black%20glass%20surface%2C%20dramatic%20directional%20spotlight%20creating%20prismatic%20light%20refractions%2C%20luxury%20fragrance%20campaign%20photography%2C%20dark%20elegant%20moody%20atmosphere%2C%20sophisticated%20evening%20aesthetic%2C%20diamond%20like%20sparkles%20and%20reflections&width=520&height=320&seq=cat-v2-perfumes-13&orientation=landscape',
  },
  {
    id: 14,
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    count: '300+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20flat%20lay%20of%20trending%20lifestyle%20products%20including%20wireless%20earbuds%2C%20minimalist%20leather%20wallet%2C%20ceramic%20mug%2C%20and%20linen%20notebook%20on%20white%20oak%20desk%20surface%2C%20bright%20morning%20sunlight%20streaming%20through%20window%2C%20modern%20creative%20workspace%2C%20clean%20organized%20aesthetic%2C%20contemporary%20product%20photography&width=520&height=320&seq=cat-v2-otherstuff-14&orientation=landscape',
  },
];

export const features = [
  {
    title: 'Kakobuy Spreadsheet',
    description: 'Find organized products with categories, links, and shopping information. Updated daily with fresh finds from global marketplaces.',
    icon: 'ri-database-2-line',
  },
  {
    title: 'CSSBuy Spreadsheet',
    description: 'Explore alternative spreadsheet resources and product research methods for informed shopping decisions.',
    icon: 'ri-file-search-line',
  },
  {
    title: 'Superbuy Spreadsheet',
    description: 'Compare Superbuy product lists and shopping resources to discover the best deals across platforms.',
    icon: 'ri-scales-3-line',
  },
  {
    title: 'Oopbuy Spreadsheet',
    description: 'Discover Oopbuy related product databases with curated categories and regular updates.',
    icon: 'ri-global-line',
  },
];

export const comparisonData = [
  { name: 'Kakobuy Spreadsheet', bestFor: 'Product discovery', mainFeature: 'Updated finds', userType: 'Beginners' },
  { name: 'CSSBuy Spreadsheet', bestFor: 'Alternative shopping', mainFeature: 'Product research', userType: 'Experienced users' },
  { name: 'Superbuy Spreadsheet', bestFor: 'Shopping guides', mainFeature: 'Product organization', userType: 'Global users' },
  { name: 'Oopbuy Spreadsheet', bestFor: 'Product sourcing', mainFeature: 'Category lists', userType: 'Researchers' },
];

export const testimonials = [
  {
    name: 'Marcus Johnson',
    role: 'Product Researcher',
    content: 'The Kakobuy Spreadsheet completely changed how I discover products. The organized categories and regular updates save me hours of searching every week. Absolutely essential for anyone serious about finding quality items.',
    rating: 4.9,
  },
  {
    name: 'Sarah Chen',
    role: 'Fashion Enthusiast',
    content: 'I was spending way too much time browsing through unorganized product lists. This spreadsheet made everything so much easier. The category breakdown is incredibly intuitive and the finds are always on trend.',
    rating: 4.8,
  },
  {
    name: 'David Park',
    role: 'Online Shopper',
    content: 'As someone new to spreadsheet-based product research, I found the guides super helpful. The comparison resources helped me understand which platforms work best for different types of products.',
    rating: 4.7,
  },
];